import { theme } from "../../../../../shared/frontend/ui";
import { LoadingOverlay } from "./LoadingOverlay";

const DOCUMENT_LOADING_MIN_HEIGHT = 360;

/** Ladeanzeige des Shared-`DocumentViewer`: m1member kennt genau eine, `LoadingOverlay` (check-ui-standards). */
export function DocumentViewerLoading() {
  const { token } = theme.useToken();
  return (
    <LoadingOverlay visible message="Loading…">
      <div style={{ background: token.colorBgLayout, height: "100%", minHeight: DOCUMENT_LOADING_MIN_HEIGHT }} />
    </LoadingOverlay>
  );
}
